import { CONSTANTS } from 'config/constants';

const { GOOGLE_PLACES_API_KEY } = CONSTANTS;
const CALLBACK_NAME = '__denthubGoogleMapsLoaded';

let loading: Promise<typeof google.maps> | undefined;

/**
 * Loads the Google Maps JavaScript API once per page (the same key as the address search
 * and static maps). Rejects when the script fails or the key is refused, and then lets a
 * later call try again.
 */
export const loadGoogleMaps = (language: string): Promise<typeof google.maps> => {
    if (typeof window.google !== 'undefined' && window.google.maps?.Map) return Promise.resolve(window.google.maps);
    if (loading) return loading;
    loading = new Promise<typeof google.maps>((resolve, reject) => {
        const fail = (reason: string) => {
            loading = undefined;
            reject(new Error(reason));
        };
        const callbacks = window as unknown as Record<string, unknown>;
        callbacks[CALLBACK_NAME] = () => resolve(window.google.maps);
        // Google calls this when the key is not allowed to use the Maps JavaScript API.
        callbacks.gm_authFailure = () => fail('GOOGLE_MAPS_AUTH_FAILURE');
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_PLACES_API_KEY}&language=${language}&callback=${CALLBACK_NAME}&loading=async&v=weekly`;
        script.async = true;
        script.onerror = () => fail('GOOGLE_MAPS_SCRIPT_FAILED');
        document.head.appendChild(script);
    });
    return loading;
};
